import { AuxiliaresCounty } from "../../types/TabelasAuxiliares/AuxiliaresCounty";
import { AuxiliaresParams } from "../../types/TabelasAuxiliares/AuxiliaresParams";
import api from "../../utils/api";
import { COUNTY_URL } from "../../utils/endpoints";

export async function getCountyById(
  params: AuxiliaresParams,
): Promise<AuxiliaresCounty[]> {
  try {
    let qs = "";
    qs += `OnlyActive=${
      params?.OnlyActive !== undefined ? params.OnlyActive : true
    }`;
    qs += params?.ParentId ? `&ParentId=${params.ParentId}` : "";

    const response = await api.get(`${COUNTY_URL}?${qs}`);
    const data: AuxiliaresCounty[] = response.data.map(
      (option: AuxiliaresCounty) => ({
        id: option.id,
        name: option.name,
        code: option.code,
        isActive: option.isActive,
        province: option.fromProvince.name,
        fromProvince: option.fromProvince,
      }),
    );

    return data;
  } catch (error) {
    throw error;
  }
}
